<template>
  <div
    :class="
      ' d-flex flex-column h-100 container pt-0 pt-lg-3 py-4 px-0 mx-auto ' +
        (Number($route.query.step) == 0
          ? 'justify-content-end form_container '
          : 'justify-content-start')
    "
  >
    <!--     <button class="new_container" @click="new_object">
      Nuevo {{ this.collectionDBname }}
    </button> -->
    <!--     <button class="delete_container" @click="delete_object">
      Eliminar {{ this.collectionDBname }}
    </button> -->
    <!-- <div v-if="newObject != null" class="h-100"> -->
    <div
      v-if="$route.query.welcome == 'true' && $route.path !== '/account'"
      class="col-12 col-md-10 container justify-self-start"
    >
      <div class="row steps">
        <div
          v-for="(step, index) in routeSteps"
          :key="step.path + index"
          class="col px-1"
          :style="'display: ' + (index == 0 ? 'none;' : 'block;')"
        >
          <div
            :class="
              index < Number($route.query.step) + 1 ? ' done step' : 'step'
            "
          ></div>
        </div>
      </div>
    </div>
    <transition name="fade" mode="out-in">
      <modal v-if="isLoading" class="z-9999">
        <loader scale="3" color="white" />
      </modal>
      <modal v-else-if="isSuccess" :swag="' z-9250 '">
        <div class="row justify-content-center">
          <div class="col-10 col-md-6">
            <h1 class="text-white poppins-bold">
              Guardado exitoso
            </h1>
          </div>

          <div class="row mt-4 justify-content-center">
            <div class="col-8 col-md-6 col-lg-4 col-xl-3">
              <img
                src="@/assets/images/icons/green-check.svg"
                height="90"
                alt="Success Check"
                class="mt-4"
              />
            </div>
          </div>
          <!-- <div class="col-10 pt-4">
        <p>
          Tu perfil se activará en unos minutos. Guarda nuestro whatsapp por si
          necesitas ayuda +34 643658547
        </p>
      </div> -->
        </div>
        <div class="row justify-content-center mt-5">
          <div class="col-8 col-md-4 col-lg-4 col-xl-3 pt-4">
            <button class="bg-accent" @click="goTo('/')">
              Aceptar
            </button>
            <!-- <button class="outlined-white">
          Aceptar
        </button> -->
          </div>
        </div>
      </modal>
      <modal v-else-if="isError" :swag="' z-8000 '">
        <div class="row justify-content-center">
          <div class="col-10 col-md-6 col-lg-4 col-xl-3">
            <h1 class="text-white poppins-bold">
              Guardado fallido
            </h1>
          </div>

          <div class="row justify-content-center">
            <div class="col-8 col-md-6 col-lg-4 col-xl-3">
              <img
                src="@/assets/images/icons/red-x.svg"
                height="90"
                alt="Error X"
                class="mt-4"
              />
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-10 col-md-6 col-lg-4 col-xl-3 pt-4">
              <p class="text-white">
                Completa los campos correctamente
              </p>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-5">
          <div class="col-8 col-md-4 col-lg-3 col-xl-3 pt-4">
            <button class="bg-accent" @click="isError = false">
              Aceptar
            </button>
            <!-- <button class="outlined-white">
          Aceptar
        </button> -->
          </div>
        </div>
      </modal>
    </transition>
    <transition-group
      name="fade"
      tag="div"
      :class="
        'col-12 col-md-10 mx-auto px-0 pb-3 row ' +
          (Number($route.query.step) == 0 ? 'mt-auto mb-md-auto' : '')
      "
    >
      <div
        v-if="$route.query.welcome == 'true' && extraInfo.step_title"
        :key="'title' + Number($route.query.step)"
        class="row justify-content-end mt-auto"
      >
        <div
          v-if="Number($route.query.step) !== 5"
          :class="
            (Number($route.query.step) == 0 ? 'pt-5' : '') +
              ' col-12 mx-auto text-left  pb-4 px-3'
          "
        >
          <h1 class="pt-5 m-0">
            {{
              Number($route.query.step) == 0 || !Number($route.query.step)
                ? ""
                : Number($route.query.step) + "."
            }}{{ extraInfo.step_title.header }}
          </h1>
          <p class="pt-2 m-0">
            {{ extraInfo.step_title.sub_header }}
          </p>
        </div>
        <div
          v-if="Number($route.query.step) == 5"
          :class="
            (Number($route.query.step) == 0 ? 'pt-5' : '') +
              ' col-12 mx-auto text-left  pb-4 align-self-end'
          "
        >
          <h1 class="pt-5 m-0">
            {{
              Number($route.query.step) == 0 || !Number($route.query.step)
                ? ""
                : Number($route.query.step) + "."
            }}Descripción
          </h1>
          <p class="pt-2 m-0">
            Cuéntales sobre ti
          </p>
        </div>
      </div>
      <div
        v-for="(formItem, index) in dataShape"
        v-bind:key="formItem.name + index"
        :class="[
          formItem.type == 'phone_number'
            ? 'col-7 form-viewer px-0'
            : formItem.type == 'phone_number_code'
            ? 'col-5 form-viewer px-0'
            : '',
        ]"
        :style="'order:' + formItem.order + ';'"
      >
        <transition name="fade" mode="out-in">
          <form-field
            v-if="isWelcome(formItem)"
            ref="form"
            :name="formItem.name"
            :label="formItem.label"
            :sub_label="formItem.sub_label"
            :type="formItem.type"
            :options="formItem.options"
            :selectedObject="selectedObject"
            :collectionDBname="collectionDBname"
            :formItem="formItem"
            @onChange="fieldUpdate"
            class=""
          />
          <!-- <form-field-account
            v-else-if="$route.path == '/account'"
            ref="form"
            :name="formItem.name"
            :label="formItem.label"
            :sub_label="formItem.sub_label"
            :type="formItem.type"
            :options="formItem.options"
            :selectedObject="selectedObject"
            :collectionDBname="collectionDBname"
            :formItem="formItem"
            :agencyButton="agencyButton"
            @onChange="fieldUpdate"
            class=""
          /> -->
        </transition>
      </div>
    </transition-group>
    <div
      v-if="$route.query.welcome == 'true' && Number($route.query.step) == 0"
      class="row mb-5"
    >
      <div
        class="col-12 col-md-8 text-center ml-auto mx-md-auto align-items-center d-flex px-4"
      >
        <div>
          <input type="checkbox" v-model="terms" @change="terms == true" />
        </div>
        <label for="checkbox" class="subtext"
          >Confirmo que soy <b>mayor de edad</b> y acepto los
          <a
            target="_blank"
            :href="'https://' + app_base + '/terminos'"
            class=""
          >
            <u> términos y condiciones</u></a
          >
          y
          <a
            target="_blank"
            :href="'https://' + app_base + '/privacidad'"
            class=""
            ><u> política de privacidad</u></a
          ></label
        >
      </div>
    </div>
    <div
      :class="
        'col-11 col-md-6 mx-auto justify-self-end ' +
          (Number($route.query.step) == 0 ? 'mt-0' : 'mt-auto')
      "
    >
      <transition
        name="fade"
        mode="out-in"
        class="col-12 align-self-end"
        tag="div"
      >
        <button
          v-if="
            ($route.query.welcome == 'false' || !$route.query.welcome) &&
              $route.params.param0 !== 'stats' &&
              $route.params.param0 !== 'photos' &&
              $route.params.param0 !== 'videos'
          "
          class="save_container bg-accent mb-2"
          @click="save_object"
        >
          Guardar
        </button>
        <button
          v-if="$route.query.welcome == 'true'"
          :class="
            'save_container bg-accent mb-2 ' +
              (terms
                ? ''
                : Number($route.query.step) == 0
                ? 'disabled'
                : Number($route.query.step) == 4
                ? ' mb-4'
                : '')
          "
          @click="save_object"
        >
          {{ Number($route.query.step) == 5 ? "Finalizar" : "Siguiente" }}
        </button>
      </transition>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import Modal from "@/components/UI/Partials/Modal.vue"
import FormField from "../Form/FormField"
/* import FormFieldAccount from "../Form/FormFieldAccount" */

import settings from "../../../api/settings"
import Loader from "@/components/UI/Loader.vue"
import utilsApi from "@/api/utils"
import { mapActions, mapGetters } from "vuex"

export default {
  data() {
    const { app_base } = settings.apiSettings
    console.log(this.dataShape, this.selectedObject)
    return {
      app_base: app_base,
      agencyButton: false,
      routeSteps: [
        { path: "account" },
        { path: "profile" },
        { path: "places" },
        { path: "prices" },
        { path: "photos" },
        { path: "profile", query: { step: 5 } },
      ],
      isSuccess: false,
      isError: false,
      isLoading: false,
      isLoadingV: true,
      terms: false,
    }
  },
  mounted() {
    /* if (this.$route.query.welcome == true) {
      console.log(
        "AQUI ESTA EL NUEVO OBJ",
        this.isNewObject,
        this.$route.query.welcome
      )
      this.isNewObject = true
    } */
    if (
      this.collectionDBname == "places" ||
      Number(this.$route.query.step) == 0
    ) {
      // window.initMap = this.initMap.bind(this)

      const plugin = document.createElement("script")
      plugin.setAttribute(
        "src",
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDwMt7oEAKKAY8KpIHR4WPEElypoQuQNcQ&libraries=places"
      )
      plugin.async = true
      plugin.defer = true
      document.head.appendChild(plugin)
    }

    this.$nextTick(function() {
      this.$watch("$refs.form.fieldValue", () => {
        //execute your code here

        console.log(
          Array.from(this.$refs.form).map(form => {
            //let holi = form.$v.$invalid
            form.$v.$touch()

            let holi = form.$v.$invalid

            form.$v.$reset()
            return holi
          })
        )
      })
    })
  },
  methods: {
    ...mapActions(["SET_ACTIVE_ALERT"]),
    isWelcome(formItem) {
      if (
        this.user.isAgency &&
        Number(this.$route.query.step) == 0 &&
        (formItem.name == "age" || formItem.name == "name")
      ) {
        if (
          this.$route.query.welcome == "true" &&
          (formItem.name == "age" || formItem.name == "name")
        ) {
          return true
        } else {
          return false
        }
      } else if (
        !this.user.isAgency &&
        Number(this.$route.query.step) == 1 &&
        (formItem.name == "age" || formItem.name == "name")
      ) {
        if (
          this.$route.query.welcome == "true" &&
          (formItem.name == "age" || formItem.name == "name")
        ) {
          return false
        } else {
          return true
        }
      } else if (
        this.$route.query.welcome == "true" &&
        Number(this.$route.query.step) !== 5
      ) {
        if (this.$route.query.welcome == "true" && formItem.welcome) {
          return true
        } else {
          return false
        }
      } else if (formItem.type == "description") {
        return true
      } else {
        if (Number(this.$route.query.step) == 5) {
          return false
        }
        return true
      }
    },
    goTo(path) {
      document.documentElement.style.overflow = "auto"
      this.isSuccess = false
      this.isLoading = false
      this.$router.push(path)
    },
    fieldUpdate(fieldObj) {
      console.log("fieldObj", fieldObj)
      if (fieldObj.name == "isAgency") {
        this.agencyButton = !this.agencyButton
        this.selectedObject[fieldObj.name] = fieldObj.value
      } else {
        this.selectedObject[fieldObj.name] = fieldObj.value
      }
    },
    async save_object() {
      // geting values
      this.$emit("onToggle")
      this.isLoading = true
      let valid = true
      let validation = Array.from(this.$refs.form).map(form => {
        let holi = form.onSave("save")
        /* .then(status => {
          if (!status) {
            return false
          }
        }) */
        if (holi.status == false) {
          console.log("NO VOY A ENVIAR FORMA INVALIDA", holi)
          valid = false
          return { status: false, name: holi.name, value: holi.value }
        } else {
          console.log("VOY A ENVIAR FORMA ", holi)
          return { status: true, name: holi.name, value: holi.value }
        }
      })

      if (valid) {
        console.log(
          "ASI QUEDO VALIDATION OK",
          validation,
          valid,
          this.collectionDBname,
          this.kCity
        )
        if (
          this.collectionDBname == "photos" &&
          this.$route.query.welcome == "true"
        ) {
          let step = Number(this.$route.query.step)
          let newPath = this.routeSteps[step + 1].path
          console.log(
            "LLEFUE A STATUS TRU Y WELCOME",
            step,
            newPath,
            status,
            this.$route
          )

          document.documentElement.style.overflow = "auto"
          this.isLoading = false

          this.isSuccess = false
          this.$router.push({
            path: newPath,
            query: { welcome: true, step: step + 1 },
          })
        } else if (
          this.collectionDBname == "videos" ||
          (this.collectionDBname == "photos" &&
            (this.$route.query.welcome == "false" ||
              !this.$route.query.welcome)) ||
          this.collectionDBname == "stats"
        ) {
          this.isLoading = false
          this.isSuccess = true
          /* this.$router.push("/") */
        } else {
          console.log(
            "PA GRABAR",
            this.selectedObject,
            this.selectedObject.schedule
          )
          if (this.selectedObject.schedule && this.selectedObject.equalDays) {
            this.selectedObject.schedule = this.selectedObject.schedule.value
            console.log(
              "FILTRADO",
              this.selectedObject.schedule,
              this.selectedObject.schedule.value
            )
          }
          console.log(
            "PA GRABAR FINAL",
            this.selectedObject,
            this.selectedObject.schedule
          )
          await this.$store
            .dispatch(`SAVE_${this.collectionDBname}`, this.selectedObject)
            .then(status => {
              console.log("LLEgue al despues de save", this.$route.query)

              if (
                status &&
                this.collectionDBname == "profile" &&
                this.$route.query.welcome == "true" &&
                this.kCity == "Online" &&
                Number(this.$route.query.step) == "1"
              ) {
                let step = Number(this.$route.query.step)
                let newPath = this.routeSteps[step + 2].path
                console.log(
                  "LLEFUE A STATUS TRU Y WELCOME",
                  step,
                  newPath,
                  status,
                  this.$route
                )

                document.documentElement.style.overflow = "auto"
                this.isLoading = false

                this.isSuccess = false
                this.$router.push({
                  path: newPath,
                  query: { welcome: true, step: step + 2 },
                })
              } else if (
                status &&
                this.$route.query.welcome == "true" &&
                Number(this.$route.query.step) < 5
              ) {
                let step = Number(this.$route.query.step)
                let newPath = this.routeSteps[step + 1].path
                console.log(
                  "LLEFUE A STATUS TRU Y WELCOME",
                  step,
                  newPath,
                  status,
                  this.$route
                )

                document.documentElement.style.overflow = "auto"
                this.isLoading = false

                this.isSuccess = false
                this.$router.push({
                  path: newPath,
                  query: { welcome: true, step: step + 1 },
                })
              } else if (status && !(this.$route.query.welcome == "true")) {
                console.log(
                  "LLEGUE A MODAL CONFIRM",
                  this.$route.query.welcome == "false",
                  this.$route.query.welcome == "true"
                )
                this.isLoading = false
                this.isSuccess = true
              } else if (status) {
                this.isLoading = false
                utilsApi.getObjects("register")
                this.SET_ACTIVE_ALERT({
                  type: "success",
                  title: "Registro Exitoso",
                  message:
                    "¡Bienvenid@! Tu perfil está en revisión. En breve nos pondremos en contacto",
                  classes: "bg-white",
                  textClasses: "text-grey-dark-80",
                  buttonText: "Ir al panel",
                  status: true,
                  to: {
                    path: "/",
                    query: null,
                  },
                })
              }
            })
        }
      } else {
        console.log("ASI QUEDO VALIDATION FLASE", validation)
        this.isLoading = false
        this.isError = true
      }

      console.log(this.collectionDBname, "LOGSS", this.selectedObject)

      // el codigo solo se actualizara en la base de datos y el store en algunos
      // casos, para profile, places, prices ...
    },
  },
  components: {
    FormField /*
    FormFieldAccount, */,
    Modal,
    Loader,
  },
  props: ["dataShape", "selectedObject", "collectionDBname"],
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        document.documentElement.style.overflow = "hidden"
        this.$emit("onUpdt")
      } else {
        document.documentElement.style.overflow = "auto"
        this.$emit("onToggle")
      }
    },
    isSuccess: function() {
      if (this.isSuccess) {
        document.documentElement.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = "auto"
      }
    },
    isError: function() {
      if (this.isError) {
        document.documentElement.style.overflow = "hidden"
      } else {
        document.documentElement.style.overflow = "auto"
      }
    },
    /* selectedObject() {
      if (this.selectedObject) {
        let valid = true
        const selected = Array.from(this.$refs.form).map(form => {
          //form.$v.fieldValue.$touch()
          let holi = form.$v.$invalid
          return holi
        })
        console.log("PUTISIMO", selected, valid)
      }
    }, */
  },
  computed: {
    ...mapGetters(["user", "kCity"]),
    extraInfo() {
      if (this.collectionDBname) {
        return this.$store.getters[`${this.collectionDBname}_extraInfo`]
      } else {
        return {}
      }
    },
    /*valid() {
       if (this.$refs.form && Array.from(this.$refs.form).length > 0) {
        let validArray = Array.from(this.$refs.form)

        let validation = validArray.map(form => {
          //let holi = form.$v.$invalid
          form.$v.$touch()

          let holi = form.$v.$invalid

          form.$v.$reset()
          return holi
        })

        return validation.every(v => v == false)
      } else {
        return false
      } */
    //let validArray = Array.from(this.$refs.form)
    /* return this.$refs.form.map(form => {
        //let holi = form.$v.$invalid
        form.$v.$touch()

        let holi = form.$v.$invalid

        form.$v.$reset()
        return holi
      })
 */
    /* if (valid && validArray) {
        return true
      } else {
        return false
      }
    },*/
  },
  updated: function() {
    this.$nextTick(function() {
      // Code that will run only after the
      // entire view has been re-rendered
      this.isLoadingV = false
      this.$emit("onUpdt")
    })
  },
}
</script>

<style lang="scss"></style>
<style lang="scss" scoped>
.form_container {
  .new_container {
    color: gray;
  }
  .delete_container {
    color: red;
  }
}
</style>
